<template>
  <div class="">
    <vs-tabs>
      <vs-tab label="FR List" icon-pack="feather" icon="icon-list">
        <vs-tabs>
          <vs-tab label="User FR">
            <ForeignExpenseList
              :listHeading="'FR List'"
              :is_foreign_remittance="true"
              :is_var="4"
              :is_other="true"
            />
          </vs-tab>
          <vs-tab label="My FR">
            <ForeignExpenseList
              :listHeading="'FR List'"
              :is_foreign_remittance="true"
              :is_var="4"
              :is_other="false"
            />
          </vs-tab>
        </vs-tabs>
      </vs-tab>
      <vs-tab label="FR Form" icon-pack="feather" icon="icon-file-text">
        <ForeignExpenseForm :form_title="'Foreign Remittance'" :is_var="4" />
      </vs-tab>
      <vs-tab label="FRR List" icon-pack="feather" icon="icon-list">
        <vs-tabs>
          <vs-tab label="User FRR">
            <ForeignExpenseList
              :listHeading="'FRR List'"
              :is_foreign_remittance="true"
              :is_var="5"
              :is_other="true"
            />
          </vs-tab>
          <vs-tab label="My FRR">
            <ForeignExpenseList
              :listHeading="'FRR List'"
              :is_foreign_remittance="true"
              :is_var="5"
              :is_other="false"
            />
          </vs-tab>
        </vs-tabs>
      </vs-tab>
      <vs-tab label="FRR Form" icon-pack="feather" icon="icon-file-text">
        <ForeignExpenseForm
          :form_title="'Foreign Remittance Return'"
          :is_var="5"
        />
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
import ForeignExpenseList from "./ForeignExpenseList.vue";
import ForeignExpenseForm from "./ForeignExpenseForm.vue";

export default {
  components: { ForeignExpenseList, ForeignExpenseForm },
};
</script>
